import request, { ResponseData } from '@/utils/request'
import { LoginResult } from '@/types/user.d'

export interface LoginParams {
  username: string
  password: string
}

export interface qualityParams {
  company_id: string
}

// 获取用户信息
export async function fetchUserInfo(): Promise<ResponseData<LoginResult>> {
  return request('/api/v1/account/logined', {
    method: 'post',
  })
}

// 登录
export async function login(params: LoginParams): Promise<ResponseData<LoginResult>> {
  return request('/api/v1/account/login', {
    method: 'post',
    data: params,
    hideErrorMessage: true,
  })
}

// 权限获取，判断使用新旧自定义质检
export async function fetchQualityRole(params: qualityParams): Promise<ResponseData<LoginResult>> {
  return request('/api/v1/qc_norm/customize_rule/seeker_types', {
    method: 'get',
    params,
  })
}

// 登出
export async function logout(): Promise<ResponseData<null>> {
  return request('/api/v1/account/logout', {
    method: 'post',
  })
}

export interface UpdatePasswordParams {
  old_password: string
  new_password: string
}

// 修改密码
export async function updatePassword(params: UpdatePasswordParams): Promise<ResponseData<null>> {
  return request('/api/v1/account/change_password', {
    method: 'post',
    data: params,
  })
}

//  切换平台
export async function switchPlatform(params: any): Promise<ResponseData<null>> {
  return request('/api/v1/account/switch_platform', {
    method: 'post',
    data: params,
  })
}

//  跟进提醒
export async function followUpReminder(params: any): Promise<ResponseData<null>> {
  return request('/api/v1/notify/send', {
    method: 'post',
    data: params,
  })
}

// 获取训练场账号信息
export async function fetchXlcInfo(params: {
  short_name: string
  password: string
  tenant_id: string
  query_exist?: boolean
}): Promise<ResponseData<any>> {
  return request('/api/v1/barrack/jump', {
    method: 'post',
    data: params,
  })
}

// 订阅voc自助洞察分析
export async function enableInsight(): Promise<ResponseData<any>> {
  return request('/api/v1/dialog/extract/on_off', {
    method: 'post',
    data: {
      enable: true,
    },
  })
}

// 获取京东NPS token
export async function fetchJDToken() {
  return request('/api/v1/jd/get_encrypt_token', {
    method: 'get',
  })
}

export async function resetPass(params: { account_id: string; password: string }) {
  return request('/api/v1/account/reset_pass', {
    method: 'post',
    data: params,
  })
}
